/** Default story when visiting `/admin/sliding` (redirects to `/admin/sliding/:id`). */
export const ADMIN_SLIDING_LANDING_STORY_ID = "9bc8b941-f129-4916-b3bb-d8b87c19f79f";

/** Full paginated list (register before `/admin/sliding/:storyId` in the router). */
export const ADMIN_SLIDING_BROWSE_PATH = "/admin/sliding/browse";

/** Admin play-session list (register before `/admin/sliding/:storyId`). */
export const ADMIN_SLIDING_PLAY_PATH = "/admin/sliding/play";

/** Play + board statistics (register before `/admin/sliding/:storyId`). */
export const ADMIN_SLIDING_STATS_PATH = "/admin/sliding/stats";

/** Season pack list (register before `/admin/sliding/:storyId`). */
export const ADMIN_SLIDING_PACKS_PATH = "/admin/sliding/packs";

/** Landing detail URL for the menu shortcut `/admin/sliding`. */
export const ADMIN_SLIDING_LANDING_PATH = `/admin/sliding/${ADMIN_SLIDING_LANDING_STORY_ID}`;

export function adminSlidingPlayDetailPath(playId) {
    return `${ADMIN_SLIDING_PLAY_PATH}/${encodeURIComponent(playId)}`;
}
